import React, { useState } from 'react';
import Picker from 'emoji-picker-react';
import { Labeled, useInput } from 'react-admin';
import Button from '@material-ui/core/Button';
import withStyles from '@material-ui/core/styles/withStyles';

const styles = {
  showHide: { marginLeft: '20px' },
};

const EmojiInput = withStyles(styles)(({ classes, ...props }) => {
  const { record } = props;
  const { input, isRequired } = useInput(props);

  const hasEmoji = record && record.emoji && /\S/.test(record.emoji);

  const [emoji, setEmoji] = useState(record ? record.emoji : null);
  const [showPicker, setShowPicker] = useState(!hasEmoji);

  const onEmojiClick = (event, emojiObject) => {
    event.preventDefault();
    setEmoji(emojiObject.emoji);

    // eslint-disable-next-line no-param-reassign
    event.target.value = emojiObject.emoji;
    input.onChange(event);
  };

  return (
    <Labeled isRequired={isRequired} {...props}>
      <span>
        {emoji ? (
          <span style={{ fontSize: '1.5em' }}>{emoji}</span>
        ) : (
          <span style={{ color: 'gray', fontWeight: 'lighter' }}>N/A</span>
        )}
        <Button
          variant="outlined"
          color="primary"
          size="small"
          className={classes.showHide}
          onClick={() => setShowPicker(!showPicker)}
        >
          {showPicker ? 'Hide' : 'Show'}
        </Button>
        {showPicker && <Picker onEmojiClick={onEmojiClick} />}
      </span>
    </Labeled>
  );
});

export default EmojiInput;
